module.exports = __webpack_public_path__ + "static/media/img_13.dd9897d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_13.jpg
// module id = 531
// module chunks = 0